/** Sort rows by a column; nulls always sink to the bottom regardless of direction. */
export function sortRows<Row, Field extends keyof Row & string>(rows: Row[], sort: { field: Field; dir: 'asc' | 'desc' }): Row[] {
  const dir = sort.dir === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const av = a[sort.field];
    const bv = b[sort.field];
    if (av == null && bv == null) return 0;
    if (av == null) return 1;
    if (bv == null) return -1;
    if (typeof av === 'string' && typeof bv === 'string') return av.localeCompare(bv) * dir;
    return (Number(av) - Number(bv)) * dir;
  });
}
